import { render, staticRenderFns } from "./Member.vue?vue&type=template&id=2ec5fe5a&scoped=true"
import script from "./Member.vue?vue&type=script&lang=js"
export * from "./Member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec5fe5a",
  null
  
)

export default component.exports